import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EpiContext from "@episerver/spa-core/Spa";
import Config from "app/Config";
import { onlyMobileML } from '../UpdatePaymentMethodBlock/updatePaymentMethodSlice';
import { regexPatterns, validationRules } from '../../../utilities/validation/validationVariables';
import TextInput from '../../Shared/TextInput/TextInput';
import images from '../UpdatePaymentMethodBlock/images/images';
import { createReport } from '../../../utilities/reports/createReport';
import { reportDWHBuilder } from '../EntityPaymentBlock/reportDWH';

import './FlowToEntityPayment.scss';

const SimpleSmsComponent = ({
  data,
  IdNumber,
  mobile,
  isPrivate,
  cmsData,
  context,
  onBack
}) => {
  const dispatch = useDispatch();
  const subscriberNumber = useSelector(state => state.selfcarePage?.selectedSubscriber?.productSubscriberNo);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isAgreed, setIsAgreed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSmsSuccess, setIsSmsSuccess] = useState(false);
  const [phoneError, setPhoneError] = useState('');



  const validatePhoneNumber = (phone) => {
    const mobilePhoneRegex = /^05\d{8}$/;
    return mobilePhoneRegex.test(phone);
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    const numbersOnly = value.replace(/\D/g, '');
    const limitedValue = numbersOnly.slice(0, 10);

    setPhoneNumber(limitedValue);
    if (phoneError) {
      setPhoneError('');
    }
  };

  const isFormValid = phoneNumber && isAgreed;

  const getCheckedItems = () => {
    const result = [];
    const customersPaymentData = data?.selectedForUpdate?.customersPaymentData;

    if (!customersPaymentData) {
      return result;
    }

    customersPaymentData.forEach((paymentItem, index) => {
      if (paymentItem.customersList) {
        paymentItem.customersList.forEach(customer => {
          if (customer.checked === true) {
            result.push({
              number: customer.number,
              name: customer.name
            });
          }
        });
      }
    });

    return result;
  };

  const getSelectedPaymentMethodLast4 = () => {
    const customersPaymentData = data?.selectedForUpdate?.customersPaymentData;
    if (!customersPaymentData || customersPaymentData.length === 0) {
      return '';
    }


    const withChecked = customersPaymentData.find(pm =>
      Array.isArray(pm.customersList) && pm.customersList.some(c => c.checked === true)
    );
    const chosen = withChecked || customersPaymentData[0];
    const rawNumber = (chosen?.paymentMethodNumber || '').toString();
    const digitsOnly = rawNumber.replace(/\D/g, '');
    return digitsOnly.slice(-4);
  };

    useEffect(() => {
    if (data) {
      const checkedItems = getCheckedItems();
    }


    const reportData = reportDWHBuilder('SMS_COMPONENT_TRIGGERED', {
      step: 'sms_component',
      accountsToUpdate: getCheckedItems().map(item => item.number).join(','),
      smsPhoneNumber: phoneNumber,
      oldCreditCardLast4: getSelectedPaymentMethodLast4(),
      subscriberNumber: IdNumber || ''
    }, { IdNumber, isPrivate });
    createReport(reportData);
  }, [data]);

    const handleSendSMS = async () => {
    if (!phoneNumber) {
      setPhoneError(validationRules.phone.required.error);
      return;
    }

    if (phoneNumber.length < 10) {
      setPhoneError(validationRules.phone.minLength.error);
      return;
    }

    if (!validatePhoneNumber(phoneNumber)) {
      setPhoneError('מספר הטלפון חייב להתחיל ב-05 ולהכיל 10 ספרות');
      return;
    }

    if (!isAgreed) {
      return;
    }

    setIsLoading(true);

    try {
      const checkedItems = getCheckedItems();
      const jsonString = JSON.stringify(checkedItems);
      const result = await dispatch(onlyMobileML({
        phoneNumber: phoneNumber,
        banNumberList: jsonString
      }));

      if (result.payload && result.payload.Header && result.payload.Header.ReturnCode === 0) {
        setIsSmsSuccess(true);


        const reportData = reportDWHBuilder('SMS_SENT_SUCCESSFULLY', {
          step: 'sms_sent',
          accountsToUpdate: checkedItems.map(item => item.number).join(','),
          smsPhoneNumber: phoneNumber,
          oldCreditCardLast4: getSelectedPaymentMethodLast4(),
          subscriberNumber: IdNumber || ''
        }, { IdNumber, isPrivate });
        createReport(reportData);
      }

    } catch (error) {
      console.error('SMS sending failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const backToLobby = () => {
    EpiContext.navigateTo(Config.lobbyUrl);
  };

  const handleGoToPersonalArea = () => {
    backToLobby();
  };

    const serviceTermsLink = cmsData?.serviceTermsLink?.value || '#';


  if (isSmsSuccess) {
    return (
      <div className='page-wrapper success-screen'>
        {onBack && (
          <div className="back-button" onClick={onBack}>
            <Image src={images.backArrow} alt="back button" />
          </div>
        )}

        <div className="success-content">
          <div className="success-icon">
            <Image src={images.successPayment} className="iconheadline" alt="payment icon" />
          </div>

          <div className="success-text">
            <div className="success-title">נשלחה הזמנה ב-sms להגדרת</div>
            <div className="success-title">אמצעי תשלום חדש</div>
          </div>

          <div className="success-description">
            ההזמנה נשלחה למספר {phoneNumber} <br/>נשלח אליך ב-sms
            קישור להגדרה ושלם בתצורה
          </div>
        </div>

        <div className="btn" onClick={handleGoToPersonalArea}>
          <div className="h50primary">
            <span className='button-text'>לאיזור האישי</span>
          </div>
        </div>
      </div>
    );
  }


  return (
    <div className='page-wrapper'>
      {onBack && (
        <div className="back-button" onClick={onBack}>
            <Image src={images.backArrow} alt="back button" />
        </div>
      )}

      <div className="content">
        <Image src={images.paymentSMS} className="iconheadline" alt="payment icon" />
        <span className="main-title">מי ישלם את החשבון?</span>
        <span className="sms-description">תישלח הזמנה ב-sms להגדרת פרטי כרטיס <br/> האשראי החדש</span>

        <div className='novalidate'>
        <TextInput
        type="text"
        placeholder="מספר טלפון"
        value={phoneNumber}
        onChange={handlePhoneChange}
        error={phoneError}
        maxLength="10"
        inputMode="numeric"
        autoComplete="tel"
        />
        </div>

        <div className="agreement-container">
          <input
            type="checkbox"
            id="agreement"
            checked={isAgreed}
            onChange={(e) => setIsAgreed(e.target.checked)}
          />
          <label htmlFor="agreement">
            אני מאשר/ת את <a href={serviceTermsLink} className="terms-link">תנאי השימוש</a>
          </label>
        </div>
      </div>

      <div className={`btn ${!isFormValid ? 'disabled' : ''}`} onClick={handleSendSMS}>
        <div className="h50primary">
          <span className='button-text'>
            {isLoading ? 'שולח...' : 'שליחת הזמנה ב-sms לבעל/ת האשראי'}
          </span>
        </div>
      </div>
    </div>
  );
};


export default SimpleSmsComponent;
